<template>
    <div class="form_wrap">
        <div class="form_content_wrap" :class="formConfig.type=='R'?'readonly_wrap':''">
            <el-form ref="form" :model="value" :rules="rules" label-width="80px">
                <el-form-item v-for="(item) in formConfig.form" :label="item.label"
                    :label-width="item.labelWidth||''" :prop="item.zdname" :key="item.zdname">
                    <el-input v-if="item.kjlx=='input' || !item.kjlx" v-model="value[item.zdname]"
                        :placeholder="'请输入'+item.label"
                        :disabled="item.readonly||formConfig.type=='R'"
                        @change="changeHandle(item,formConfig.form)"></el-input>
                    <el-input v-if="item.kjlx=='textarea'" type="textarea" autosize
                        v-model="value[item.zdname]" :placeholder="'请输入'+item.label"
                        :disabled="item.readonly||formConfig.type=='R'"
                        @change="changeHandle(item,formConfig.form)"></el-input>
                    <el-input v-if="item.kjlx=='number'" type="number" v-model="value[item.zdname]"
                        :placeholder="'请输入'+item.label"
                        :disabled="item.readonly||formConfig.type=='R'"
                        @change="changeHandle(item,formConfig.form)"></el-input>
                    <el-date-picker v-if="item.kjlx=='date'" v-model="value[item.zdname]"
                        type="date" value-format="yyyy-MM-dd" class="my_form"
                        :disabled="item.readonly||formConfig.type=='R'" placeholder="选择日期"
                        @change="changeHandle(item,formConfig.form)">
                    </el-date-picker>
                    <el-date-picker v-if="item.kjlx=='datetime'" v-model="value[item.zdname]"
                        type="datetime" value-format="yyyy-MM-dd HH:mm:ss" class="my_form"
                        :disabled="item.readonly||formConfig.type=='R'" placeholder="选择日期"
                        @change="changeHandle(item,formConfig.form)">
                    </el-date-picker>
                    <el-radio-group :disabled="item.readonly||formConfig.type=='R'"
                        v-model="value[item.zdname]" v-if="item.kjlx=='radio'">
                        <el-radio :label="item2.value" v-for="(item2, index2) in formatList(item)"
                            @change="changeHandle(item,formConfig.form)" :key="index2">
                            {{item2.label}}</el-radio>
                    </el-radio-group>
                    <el-select v-if="item.kjlx=='select'" v-model="value[item.zdname]"
                        :placeholder="'请选择'+item.label" class="my_form"
                        :disabled="item.readonly||formConfig.type=='R'"
                        @change="changeHandle(item,formConfig.form)">
                        <el-option v-for="(item2, index2) in formatList(item)" :key="index2"
                            :value="item2.value" :label="item2.label">
                        </el-option>
                    </el-select>
                    <el-select v-if="item.kjlx=='selects'" multiple
                        :collapse-tags="formConfig.type=='R'?false:true" filterable
                        v-model="value[item.zdname]" :placeholder="'请选择'+item.label" class="my_form"
                        :disabled="item.readonly||formConfig.type=='R'"
                        @change="changeHandle(item,formConfig.form)">
                        <el-option v-for="(item2, index2) in formatList(item)" :key="index2"
                            :value="item2.value" :label="item2.label">
                        </el-option>
                    </el-select>

                    <el-input v-if="item.kjlx=='validateCode'" type="number"
                        v-model="value[item.zdname]" :placeholder="'请输入'+item.label"
                        :disabled="item.readonly||formConfig.type=='R'"
                        @change="changeHandle(item,formConfig.form)"></el-input>
                    <el-button v-if="item.kjlx=='validateCode'"
                        @click="getPhoneCode(item,formConfig.form)" type="primary"
                        :disabled="phoneCodeSec<60">
                        {{ phoneCodeSec < 60?phoneCodeSec+'秒后获取':'获取验证码'}}</el-button>

                    <!-- <el-button
                        v-if="item.buttonFunction&&item.kjlx!='position'&&item.kjlx!='validateCode'&&formConfig.type!='R'"
                        @click="clickHandle(item,formConfig.form)" type="primary"
                        icon="el-icon-more"></el-button>

                    <div class="fj" v-if="item.kjlx=='file'">
                        <el-input  v-model="item.value" disabled
                            :placeholder="item.label"></el-input>
                        <el-button-group class="upload">
                            <el-button @click="upload(item)" v-if="formConfig.type!='R'"
                                type="primary"  icon="el-icon-upload">
                            </el-button>
                            <el-button @click="viewFile(item)" type="primary"
                                icon="el-icon-view"></el-button>
                        </el-button-group> -->

                    <!-- <div class="remark_wrap" v-html="item.remark"></div> -->
                    <!-- </div> -->
                </el-form-item>

            </el-form>
            <div class="foot-btn-wrap">
                <el-button type="primary" @click="handle">确认</el-button>
                <el-button @click="$emit('close')">取消</el-button>
            </div>
        </div>
        <common-upload :uploadConfig="uploadConfig"></common-upload>
        <common-position-choose v-if="showMap"></common-position-choose>
    </div>
</template>

<script>
import CommonUpload from "@/components/CommonUpload/index";
import CommonPositionChoose from "@/components/CommonPositionChoose/index";
export default {
  components: {
    CommonUpload,
    CommonPositionChoose
  },
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    formConfig: {
      type: Object,
      default: () => { }
    },
    type: {
      type: String,
      default: "add"
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {
    event: "change"
  },
  name: "Form-Curd",
  created() {
    var form = this.formConfig.form;
    var value = {};
    var rules = {};
    form.forEach(item => {
      if (this.type == "add") {//修改
        if (item.defVal !== undefined) {
          value[item.zdname] = item.defVal;
        } else {
          value[item.zdname] = "";
        }
      }
      if (item.required) {
        rules[item.zdname] = [{ required: true, message: `请输入${item.label}` }]
      }
    })
    this.rules = rules;
    if (this.type == "add") {
      this.$emit("change", value);
      this.$emit("on-change", value);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.form.clearValidate()
    })
  },
  methods: {
    handle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("handle", this.value)
        }
      })
    },
    async getPhoneCode(item) {
      if (!item.value) {
        return this.$message.warning("请先填写手机号");
      }
      if (item.validateCodeUrl) {
        let res = await this.$api.post(item.validateCodeUrl, {
          phone: item.value
        });
        if (res.success) {
          this.formConfig.form[item.idZdname].value = res.data.id
          this.phoneCodeSec--;
          this.phoneCodeTimer = setInterval(() => {
            this.phoneCodeSec--;
            if (this.phoneCodeSec == 0) {
              clearInterval(this.phoneCodeTimer);
              this.phoneCodeSec = 60;
            }
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    formatList(item) {
      return item.list;
    },
    clickChildHandle(item, data, form, parItem) {
      if (item.buttonFunction && this.$parent[item.buttonFunction]) {
        this.$parent[item.buttonFunction](
          data[item.zdname],
          item,
          data,
          form,
          parItem
        );
      }

    },
    clickHandle(item, form) {
      if (item.buttonFunction && this.$parent[item.buttonFunction]) {
        this.$parent[item.buttonFunction](item.value, item, form);
      }

    },
    changeHandle(item, form) {
      if (item.changeFunction && this.$parent[item.changeFunction]) {
        this.$parent[item.changeFunction](item.value, item, form);
      }
      if (item.changeFunction && this.$parent.$parent[item.changeFunction]) {
        this.$parent.$parent[item.changeFunction](item.value, item, form);
      }

    },
    upload(item, item2) {
      this.uploadConfig.show = true;
      this.uploadConfig.type = "edit";
      if (item2) {
        this.uploadConfig.files = item2[item.zdname];
        this.fileZdname = item.zdname;
        this.tmpChosenData2 = item2;
      } else {
        this.uploadConfig.files = item.value;
        this.tmpChosenData = item;
      }
    },
    viewFile(item, item2) {
      this.uploadConfig.show = true;
      this.uploadConfig.type = "view";
      if (item2) {
        this.uploadConfig.files = item2[item.zdname];
        this.fileZdname = item.zdname;
        this.tmpChosenData2 = item2;
      } else {
        this.uploadConfig.files = item.value;
        this.tmpChosenData = item;
      }
    },
    async getData() {
      let res = await this.$d[this.formConfig.getDetailUrl](
        this.formConfig.params
      );
      if (res.success) {
        var d = res.data;
        this.d = d;
        var f = this.formConfig.form;
        for (var i in f) {
          f[i]["value"] = d[i];
        }
      } else {
        this.$message.warning(res.msg);
      }
    },
    reset() {
      var f = this.formConfig.form;
      this.formConfig.params = {};
      for (var i in f) {
        if (f[i]["value"] instanceof Array) {
          f[i]["value"] = [];
        } else {
          f[i]["value"] = null;
        }
      }
    },
    hideModel() {
      this.reset();
    },
  },

  data() {
    return {
      rules: {},
      phoneCodeSec: 60,
      phoneCodeTimer: null,
      showMap: false,
      tmpChosenData: {},
      tmpChosenData2: {},
      tmpPositionObj: {},
      fileZdname: "",
      loading: false,
      uploadConfig: {
        type: "",
        show: false,
        files: "",
        id: "common_upload",
        title: "上传附件",
        fileNoToken: this.formConfig.fileNoToken,
        save: res => {
          if (this.fileZdname) {
            this.tmpChosenData2[this.fileZdname] = res;
          } else {
            this.tmpChosenData.value = res;
          }
          this.uploadConfig.show = false;
          this.fileZdname = "";
        }
      }
    };
  },


};
</script>

<style lang="scss" scoped>
.form_content_wrap {
  height: 100%;
  background: #ffffff;
  overflow: auto;
  padding: 5px 10px 15px;
}
.form {
  background: #ffffff;
  padding: 5px 10px 15px;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
  .form_item {
    display: flex;
    width: 50%;
    padding: 1.3vh 0.5vw;
    align-items: center;
    min-height: 60px;
    .lab {
      flex: 0 0 4vw;
      font-weight: bold;
      color: #409eff;
      margin-right: 0.3vw;
      font-size: 14px;
    }
    .con {
      flex: 1;
      overflow: hidden;
      .con_inp_wrap {
        width: 100%;
        display: flex;
        align-items: center;
      }
      .el-button {
        margin-left: 3px;
      }
      .remark_wrap {
        width: 100%;
        color: #b42f2f;
        font-size: 14px;
        padding-top: 3px;
      }
    }
  }
  .w_33 {
    width: 33% !important;
  }
  .w_80 {
    width: 80% !important;
  }
  .w_100 {
    width: 100% !important;
  }
  .has_child_item {
    width: 100%;
    padding: 0 20px;
    .has_child_item_title {
      color: #409eff;
      font-weight: 700;
      font-size: 17px;
      padding: 10px;
      border: 1px solid #409eff;
      border-left: 5px solid #409eff;
      border-radius: 0 5px 5px 0;
      margin: 10px 0 20px;
      background: #fff;
      box-shadow: 0 0 12px 0 rgba(135, 214, 238, 0.2);
      padding-bottom: 15px;
      .btn_group {
        margin-left: 20px;
        float: right;
      }
    }
  }
}

.form_2_level {
  background: #f0f7fd;
}
.form_3_level {
  background: #dff0fa;
  .con {
    display: flex;
  }
  align-items: center;
}
.required::before {
  content: '* ';
  color: red;
}
.el-tabs {
  background: #ffffff;
}
.my_form {
  width: 100% !important;
}
.tools {
  width: 100%;
}
.fj {
  display: flex;
  align-items: center;
  width: 100%;
  .upload {
    margin-left: 5px;
    display: flex;
  }
}
.foot-btn-wrap {
  padding-top: 10px;
  display: flex;
  align-content: center;
  justify-content: center;
}
</style>
